import Notice from "assets/air/notice.png";
import { ilshinGroupPhone } from "hooks/utils/util";

const SignUp = ({ status }: { status: string }) => {
    return (
        <div className="bg-white w-full max-w-[600px] px-[100px] py-[50px] flex flex-col responsive1200:px-[4%] responsive1200:py-[10%]">
            <div className="flex flex-col items-center text-lg text-[#333] justify-center">
                <img src={Notice} alt="Notice" />
                <p className="mt-7 text-center break-keep responsive450:text-[16px]">홈페이지에서 회원가입 서비스는 하지 않습니다</p>
                <p className="text-[#1744ad] text-center break-keep responsive450:text-[16px]">
                    회원가입이 필요하신 경우 고객센터로 문의 바랍니다.
                </p>
            </div>
            <hr className="my-8" />
            <p className="text-lg text-[#333] flex items-center justify-center flex-wrap">
                고객센터 대표번호
                <span
                    className={`text-[40px] font-bold pl-5 text-nowrap responsive450:text-[26px] ${status === "air" ? "text-air" : status === "morning" ? "text-new" : status === "quick" ? "text-quick" : "text-express"}`}
                >
                    {ilshinGroupPhone(status)}
                </span>
            </p>
        </div>
    );
};

export default SignUp;
